import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";

export type QuickstartGuideName =
  | "ADD_FIRST_EXERCISE"
  | "FILTER_LIBRARY"
  | "ADD_COMPLEMENTARY_EXERCISES"
  | "ADD_ALTERNATIVE_EXERCISES"
  | "DUPLICATE_SESSION"
  | "START_SESSION";

export const trackStartQuickstart = (guide: QuickstartGuideName): void => {
  analyticsService.trackEvent({
    category: AnalyticsCategory.PROGRAM,
    action: "startQuickstartGuide",
    params: [guide],
  });
};

export const trackCompleteQuickstart = (guide: QuickstartGuideName): void => {
  analyticsService.trackEvent({
    category: AnalyticsCategory.PROGRAM,
    action: "completeQuickstartGuide",
    params: [guide],
  });
};

export const mapStepIdToGuideName = (id: string): QuickstartGuideName | null => {
  switch (id) {
    case "add-exercise":
      return "ADD_FIRST_EXERCISE";
    case "filter-library":
      return "FILTER_LIBRARY";
    case "add-complementary":
      return "ADD_COMPLEMENTARY_EXERCISES";
    case "add-alternatives":
      return "ADD_ALTERNATIVE_EXERCISES";
    case "duplicate-session":
      return "DUPLICATE_SESSION";
    case "start-program":
      return "START_SESSION";
    default:
      return null;
  }
};
